import { useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import Hover from "./Hover";
import styles from "./styles.module.scss";
import { FC, Option, OptionsModals, Props } from "./typings";

import deskService from "api/deskService";
import listService from "api/listService";
import BinIcon from "assets/icons/bin.svg?react";
import DeskIcon from "assets/icons/book.svg?react";
import DeskRemoveIcon from "assets/icons/bookr.svg?react";
import CalendarIcon from "assets/icons/calendar.svg?react";
import TaskIcon from "assets/icons/task.svg?react";
import AttachIcon from "assets/icons/case.svg?react";
import FlagIcon from "assets/icons/flag_border.svg?react";
import ForwardIcon from "assets/icons/forward.svg?react";
import LabelIcon from "assets/icons/label-new.svg?react";
import ReplyAllIcon from "assets/icons/reply_all.svg?react";
import ReplyIcon from "assets/icons/reply.svg?react";
import SignIcon from "assets/icons/sign.svg?react";
import RestoreIcon from "assets/icons/reverse.svg?react";
import ShareIcon from "assets/icons/share.svg?react";
import PassIcon from "assets/icons/fast_forward.svg?react";
import EditIcon from "assets/icons/mode_edit.svg?react";
import ModalsManagerContext from "contexts/ModalsManager";
import PackagesContext from "contexts/PackagesContext";
import { ItemKind } from "dto/IKindItems";
import { IPackage } from "dto/IPackage";
import { EParcelDeliveryCategory } from "dto/Mailroom/IDispatchChart";
import { useNavigate, useParams } from "react-router-dom";
import { useOnClickOutside } from "usehooks-ts";
import { ENotificationType, notification } from "utils/notification";
import { getErrorMessage } from "utils/getErrorMessage";
import Dropdown from "./Dropdown";
import Elements from "./Elements";
import { AbilityContext } from "contexts/AbilityContext";
import { useKeyPressEvent } from "react-use";
import { useThreadStore } from "store/thread.store";
import AppContext from "contexts/AppContext";
import { isInputFocused } from "utils/isInputFocused";
import DossierIcon from "assets/icons/folder_dossier_added.svg?react";
import { useTranslation } from "react-i18next";

const OptionsCard: FC<Props> = ({
  showOptions,
  toggle,
  selectedElements,
  pack,
  refWrapper,

  scrollWrapper,
  rightSide = false,
  refetch,
  dropdown,
  setSelectedElements,
  isRightClicked = false,
  thread = false,
  outsideOptions,
  isCase,
  showEditStatus,
  setShowEditStatus,
  showEditTags,
  setShowEditTags,
  showShare,
  setShowShare,
  size = "normal",
  setShowAddToDossier,
}) => {
  const { t } = useTranslation();
  const { activePanel } = useContext(AppContext);
  // const islistHovered = useHover(scrollWrapper);

  useKeyPressEvent("Delete", () => {
    if (!showOptions) return;

    console.log("Handle delete key on list", activePanel);
    if (activePanel === "left" && !isInputFocused()) {
      handleDeletePackage();
    }
  });

  const containerRef = useRef(null);
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const { filterId, status } =
    useParams();
  const { packages, setPackages } = useContext(PackagesContext);
  const { messages: threadMessages, setMessages: setThreadMessages } =
    useThreadStore();
  const { mutate: deletePackage } = listService.useDeleteList();
  const { mutate: setDesk } = deskService.useSetDesk();
  const { mutate: restore } = listService.useRestorePackage();
  const {
    modals,
    setModals,
    setOptions: setModalOptions,
  } = useContext(ModalsManagerContext);
  const isLetters = status === "pisma";
  const [, setOptionsModals] = useState<OptionsModals>({
    attach: false,
    status: false,
    remove: false,
    tag: false,
    sign: false,
    calendar: false,
    desk: false,
    reply: false,
    redirect: false,
    // share: false,
  });

  const [options, setOptions] = useState<Option[]>([]);

  const [lastSelected, setLastSelected] = useState(0);

  const checkCanReply = (): boolean => {
    if (pack.Kind === ItemKind.ContactMessage) {
      if (!pack.S4) {
        notification({
          type: ENotificationType.INFO,
          title: t("optionsCard.noEmailAddress"),
          text: t("errors.noSenderEmail"),
        });
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    if (
      lastSelected > selectedElements.length &&
      selectedElements.length === 1
    ) {
      const nextCursor = selectedElements.at(0);
      if (nextCursor.Thread) {
        navigate(
          `/packages/thread/${filterId}/${status}/${nextCursor.Kind}/${nextCursor.Thread.Id}/${nextCursor.Id}`,
        );
      } else {
        navigate(
          `/packages/${filterId}/${status}/${nextCursor.Kind}/${nextCursor.Id}`,
        );
      }
    }
    setLastSelected(selectedElements.length);
  }, [selectedElements]);

  useEffect(() => {
    const opt = [
      {
        name: pack?.IsDeskActive ? t("optionsCard.unpin") : t("optionsCard.addToDesk"),
        Icon: pack?.IsDeskActive ? DeskRemoveIcon : DeskIcon,
        callback: () => {
          // if (pack?.IsDeskActive && !isRightClicked && !rightSide) {
          //   updateModal("desk", true);
          //   return;
          // }

          handleAddToDesk();
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("chat.addToDossier"),
        Icon: DossierIcon,
        callback: () => {
          // if (pack?.IsDeskActive && !isRightClicked && !rightSide) {
          //   updateModal("desk", true);
          //   return;
          // }

          setShowAddToDossier(true);
        },
        additional: false,
        isEnabled: !!setShowAddToDossier,
        canMultiple: true,
      },
      {
        name: t("common.status"),
        Icon: FlagIcon,
        callback: () => {
          if (setShowEditStatus) {
            setShowEditStatus(true, rightSide ? containerRef : null);
          } else {
            localStorage.setItem("package", JSON.stringify(pack));
            localStorage.setItem("packages", JSON.stringify(selectedElements));
            setModals({ ...modals, editStatus: true, hide: false });
          }
        },
        additional: true,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("common.share"),
        Icon: ShareIcon,
        callback: () => {
          if (setShowShare) {
            setShowShare(true, rightSide ? containerRef : null);
          }
        },
        additional: true,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("optionsCard.internalPass"),
        Icon: PassIcon,
        callback: () => {
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, internalPass: true, hide: false });
        },
        additional: true,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("optionsCard.decree"),
        Icon: PassIcon,
        callback: () => {
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, decree: true, hide: false });
        },
        additional: true,
        isEnabled: pack?.Kind === ItemKind.Parcel,
        canMultiple: false,
      },
      {
        // Edycja zarejestrowanej przesyłki przychodzącej (biuro podawcze) — kreator w trybie
        // edycji; BE sprawdza, czy wołający może edytować (rejestrujący / właściciel / biuro).
        name: t("optionsCard.editIncomingParcel"),
        Icon: EditIcon,
        callback: () => {
          setModalOptions({ editParcelId: pack.Id });
          setModals({ ...modals, editIncomingParcel: true, hide: false });
        },
        additional: true,
        isEnabled: pack?.Kind === ItemKind.Parcel && !pack?.IsRemoved,
        canMultiple: false,
      },
      {
        name: t("optionsCard.generateLetters"),
        Icon: PassIcon,
        callback: () => {
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, generateLetters: true, hide: false });
        },
        additional: true,
        isEnabled: pack?.Kind === ItemKind.EditorDocument,
        canMultiple: false,
      },
      {
        name: t("optionsCard.dispatch"),
        Icon: PassIcon,
        callback: () => {
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, dispatch: true, hide: false });
        },
        additional: true,
        isEnabled: pack?.Kind === ItemKind.OutgoingParcel,
        canMultiple: false,
      },
      {
        // Zadanie 1 — potwierdzenie odbioru osobistego przesyłki WYCHODZĄCEJ,
        // której forma doręczenia to „Odbiór osobisty" (PersonalPickup=1).
        // Kategoria formy pochodzi z widoku listy (kolumna N3 → DeliveryCategory).
        name: t("optionsCard.confirmPickup"),
        Icon: SignIcon,
        callback: () => {
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, confirmPickup: true, hide: false });
        },
        additional: true,
        isEnabled:
          pack?.Kind === ItemKind.OutgoingParcel &&
          pack?.DeliveryCategory === EParcelDeliveryCategory.PersonalPickup,
        canMultiple: false,
      },
      {
        // Zadanie 4 — rejestracja zwrotki ZPO dla pojedynczej WYSŁANEJ przesyłki.
        // Tylko nadane (SendDate) — inaczej powstałby rekord „odebrano zanim nadano".
        name: t("optionsCard.registerReception"),
        Icon: PassIcon,
        callback: () => {
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, registerReception: true, hide: false });
        },
        additional: true,
        isEnabled: pack?.Kind === ItemKind.OutgoingParcel && !!pack?.SendDate,
        canMultiple: false,
      },
      {
        name: t("forms.label"),
        Icon: LabelIcon,
        callback: () => {
          if (setShowEditTags) {
            setShowEditTags(true, rightSide ? containerRef : null);
          } else {
            localStorage.setItem("package", JSON.stringify(pack));
            setModals({ ...modals, editLabels: true, hide: false });
          }
        },
        additional: true,
        isEnabled: true,
        canMultiple: true,
        splitterAfter: true,
      },
      {
        name: t("actions.createEventLabel"),
        Icon: CalendarIcon,
        callback: () => {
          //updateModal("calendar", true);
          localStorage.setItem("options_package", JSON.stringify(pack));
          setModals({ ...modals, createEvent: true, hide: false });
        },
        additional: false,
        isEnabled: ability.can("accessModule", "tasks"),
        canMultiple: false,
      },

      {
        name: t("actions.createTaskLabel"),
        Icon: TaskIcon,
        callback: () => {
          //updateModal("calendar", true);
          localStorage.setItem("options_package", JSON.stringify(pack));
          setModals({ ...modals, createTask: true, hide: false });
        },
        additional: false,
        isEnabled: ability.can("accessModule", "tasks"),
        canMultiple: false,
      },

      {
        name: t("packages.replyAction"),
        Icon: ReplyIcon,
        callback: () => {
          if (checkCanReply()) {
            updateModal("reply", true);
            handleClickReply(false, false);
          }
        },
        additional: true,
        isEnabled:
          pack?.Kind !== ItemKind.CourtPortalDocument &&
          pack?.Kind !== ItemKind.CourtPortalDeliverance,
        canMultiple: false,
      },
      {
        name: t("optionsCard.replyAll"),
        Icon: ReplyAllIcon,
        callback: () => {
          if (checkCanReply()) {
            updateModal("reply", true);
            handleClickReply(true, false);
          }
        },
        additional: false,
        isEnabled:
          pack?.Kind !== ItemKind.CourtPortalDocument &&
          pack?.Kind !== ItemKind.CourtPortalDeliverance,
        canMultiple: false,
      },
      {
        name: t("common.forward"),
        Icon: ForwardIcon,
        callback: () => {
          handleClickReply(false, true);
        },
        additional: false,
        isEnabled: true,
        canMultiple: false,
      },

      {
        name: t("certificate.signElectronically"),
        Icon: SignIcon,
        callback: () => {
          updateModal("sign", true);
        },
        additional: true,
        isEnabled: isLetters && !pack.S4,
        canMultiple: false,
      },

      {
        name: pack?.isDelete || pack?.IsRemoved ? t("common.restore") : t("common.delete"),
        Icon: pack?.isDelete || pack?.IsRemoved ? RestoreIcon : BinIcon,
        callback: () => {
          if (pack?.isDelete || pack?.IsRemoved) {
            restorePackage();
            return;
          }
          handleDeletePackage();
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
        splitterBefore: true,
      },
    ];

    // if (rightSide) {
    //   opt = opt.map((o) => {
    //     o.additional = true;
    //     return o;
    //   });
    // }

    if (isCase) {
      opt.unshift({
        name: t("common.move"),
        Icon: AttachIcon,
        callback: () => {
          localStorage.setItem("move", "true");
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, attachCase: true, hide: false });
        },
        additional: false,
        isEnabled:
          pack?.Kind !== ItemKind.CourtPortalDocument &&
          pack?.Kind !== ItemKind.CourtPortalDeliverance &&
          ability.can("accessModule", "cases"),
        canMultiple: true,
      });
    } else {
      opt.unshift({
        name: t("tooltips.linkToCase"),
        Icon: AttachIcon,
        callback: () => {
          if (selectedElements.length > 1) {
            localStorage.setItem("packages", JSON.stringify(selectedElements));
          }
          localStorage.setItem("package", JSON.stringify(pack));
          setModals({ ...modals, attachCase: true, hide: false });
          // updateModal("attach", true);
        },
        additional: false,
        isEnabled: ability.can("accessModule", "cases"),
        canMultiple: true,
      });
    }

    setOptions(outsideOptions ?? opt);
  }, [
    showOptions,
    isRightClicked,
    pack,
    dropdown,
    rightSide,
    outsideOptions,
    selectedElements,
    pack?.IsDeskActive,
  ]);

  const handleAddToDesk = () => {
    console.log("odpalam funkcje");
    let newPacks = [...packages];
    let isDeskActive: boolean | null = null;
    const items = [];

    if (selectedElements.length > 1) {
      newPacks = newPacks.map((p) => {
        if (selectedElements.find((a) => a.Id === p.Id || a.Id === pack.Id)) {
          p.IsDeskActive = !p.IsDeskActive;
          if (isDeskActive === null) {
            isDeskActive = !p.IsDeskActive;
          }
          items.push({ Id: p.Id, Kind: p.Kind });
        }
        return p;
      });
    } else {
      console.log(pack);
      const el = newPacks.find((p) => p.Id === pack.Id);
      if (el) {
        el.IsDeskActive = !el.IsDeskActive;
        isDeskActive = !el.IsDeskActive;
        items.push({ Id: el.Id, Kind: el.Kind });
      }
    }

    setPackages(newPacks);

    setDesk(
      {
        Items: items,
        Show: !isDeskActive,
      },
      {
        onError: () => {
          notification({
            type: ENotificationType.ERROR,
            title: t("errors.occurred"),
            text: t("optionsCard.tryAgainLaterEllipsis"),
          });
        },
      },
    );
  };

  const updateModal = (key: keyof OptionsModals, value: boolean) => {
    setOptionsModals((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleClickReply = (replyAll: boolean, forward: boolean) => {
    setModals({ ...modals, createPost: true, hide: false });

    const data = {
      id: pack.Id,
      kind: pack.Kind,
      title: pack.S1.replace("<em>", "").replace("</em>", ""),
      case: pack.Case,
    };

    if (!forward) {
      sessionStorage.setItem("reply", JSON.stringify(data));
      sessionStorage.setItem("type", replyAll ? "replyall" : "reply");
    } else {
      sessionStorage.setItem("forward", JSON.stringify(data));
      sessionStorage.setItem("type", "forward");
    }
  };

  const handleDeletePackage = () => {
    const newPacks = [...packages];

    let elementsToDelete: { Id: string; Kind: ItemKind }[] = [];
    // Pozycje ukryte od razu, przed odpowiedzią serwera — przy odmowie wracają na listę.
    const hidden: IPackage[] = [];
    let undoThread: (() => void) | null = null;

    if (selectedElements.length > 1) {
      for (const p of selectedElements) {
        const o = newPacks.find((op) => op.Id === p.Id);
        if (o) {
          o.isDelete = true;
          hidden.push(o);
        }
      }

      setPackages(newPacks);

      elementsToDelete = selectedElements.map((m) => ({
        Id: m.Id,
        Kind: m.Kind,
      }));
    } else {
      const toRemove = newPacks.find((f) => f.Id === pack.Id);

      if (toRemove) {
        toRemove.isDelete = true;
        hidden.push(toRemove);
      }

      if (pack.Thread?.Id && threadMessages[pack.Thread.Id]) {
        const newThreadElements = [...threadMessages[pack.Thread.Id]];
        const threadElementToRemove = newThreadElements.find(
          (f) => f.Id === pack.Id,
        );

        if (threadElementToRemove) {
          threadElementToRemove.isDelete = true;
          setThreadMessages[pack.Thread.Id] = newThreadElements;

          const threadRoot = newPacks.find(
            (x) => x.Thread?.Id == pack.Thread?.Id,
          );

          if (threadRoot) {
            threadRoot.Thread.Count -= 1;
          }

          undoThread = () => {
            threadElementToRemove.isDelete = false;
            if (threadRoot) {
              threadRoot.Thread.Count += 1;
            }
          };
        }
      }

      setPackages(newPacks);
      elementsToDelete = [{ Id: pack.Id, Kind: pack.Kind }];
    }

    deletePackage(
      {
        Items: elementsToDelete,
      },
      {
        onSuccess: () => {
          // refetch();
        },
        onError: (err) => {
          // Serwer odrzuca całą operację (np. wysłana przesyłka EBI nie trafia do kosza) — lista wraca do stanu sprzed usunięcia.
          hidden.forEach((p) => {
            p.isDelete = false;
          });
          undoThread?.();
          setPackages([...newPacks]);

          notification({
            type: ENotificationType.ERROR,
            title: t("errors.occurred"),
            text: getErrorMessage(err) || t("optionsCard.tryAgainLaterEllipsis"),
          });
        },
      },
    );
  };

  const restorePackage = () => {
    const newPacks = [...packages];
    let elementsToDelete: { Id: string; Kind: ItemKind }[] = [];
    if (selectedElements.length > 1) {
      setPackages(
        newPacks.filter((p) => !selectedElements.find((a) => a.Id === p.Id)),
      );
      elementsToDelete = selectedElements.map((m) => ({
        Id: m.Id,
        Kind: m.Kind,
      }));
    } else {
      setPackages(newPacks.filter((p) => p.Id !== pack.Id));
      elementsToDelete = [{ Id: pack.Id, Kind: pack.Kind }];
    }
    restore(
      {
        Items: elementsToDelete,
      },
      {
        onSuccess: () => {
          refetch();
        },
        onError: () => {
          notification({
            type: ENotificationType.ERROR,
            title: t("errors.occurred"),
            text: t("optionsCard.tryAgainLaterEllipsis"),
          });
        },
      },
    );
  };

  useOnClickOutside(containerRef, () => {
    if (dropdown && showOptions) {
      toggle();
    }
  });

  if ((showEditTags || showEditStatus || showShare) && !rightSide) {
    return <></>;
  }

  if (dropdown) {
    return (
      <Dropdown
        toggle={toggle}
        options={options}
        refWrapper={refWrapper}
        rightSide={rightSide || dropdown}
        scrollWrapper={scrollWrapper}
        showOptions={showOptions}
        selectedElements={selectedElements}
        setSelectedElements={setSelectedElements}
        size={size}
      />
    );
  }

  if (!dropdown && rightSide) {
    return (
      <div ref={containerRef} className={styles.wrap}>
        <Hover
          toggle={toggle}
          rightSide={rightSide}
          scrollWrapper={scrollWrapper}
          options={options}
          refWrapper={refWrapper}
          showOptions={showOptions}
          selectedElements={selectedElements}
          setSelectedElements={setSelectedElements}
          thread={thread}
          size={size}
        />
      </div>
    );
  }

  return ReactDOM.createPortal(
    <div ref={containerRef} className={styles.wrap}>
      {(selectedElements.length === 1 || selectedElements.length === 0) && (
        <>
          {!dropdown && (
            <Hover
              toggle={toggle}
              rightSide={rightSide}
              scrollWrapper={scrollWrapper}
              options={options}
              refWrapper={refWrapper}
              showOptions={showOptions}
              selectedElements={selectedElements}
              setSelectedElements={setSelectedElements}
              thread={thread}
              size={size}
            />
          )}
        </>
      )}
      {selectedElements.length > 1 && (
        <Elements
          toggle={() => {}}
          rightSide={rightSide}
          scrollWrapper={scrollWrapper}
          options={options}
          refWrapper={refWrapper}
          showOptions={true}
          selectedElements={selectedElements}
          setSelectedElements={setSelectedElements}
          size={size}
        />
      )}
    </div>,
    document.body,
  );
};

export default OptionsCard;
